(() => {
const init = (root = document) => {
root.querySelectorAll('.pbs-pdp-benefits').forEach(marker => {
const section = marker.closest('.shopify-section');
const info = section?.querySelector('.product__info-container');
const gallery = section?.querySelector('.product__media-wrapper');
if (!info || !gallery || gallery.dataset.pbsHeightBound) return;
gallery.dataset.pbsHeightBound = 'true';
const sync = () => {
if (!gallery.isConnected) { observer.disconnect(); return; }
const height = info.getBoundingClientRect().height;
if (height > 0) {
gallery.style.setProperty('--pbs-gallery-height', height + 'px');
gallery.classList.add('pbs-gallery-aligned');
}
};
const observer = new ResizeObserver(sync);
observer.observe(info);
sync();
});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
else init();
document.addEventListener('shopify:section:load', event => init(event.target));
})();